import { render, staticRenderFns } from "./recordMapButton.vue?vue&type=template&id=6c07eebf&lang=pug&"
import script from "./recordMapButton.vue?vue&type=script&lang=js&"
export * from "./recordMapButton.vue?vue&type=script&lang=js&"
import style0 from "./recordMapButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports